export const favoriteStops = 'favoriteStops';
export const plazaEspaña = {
  stop: 22767,
  routeShortNames: ['161', '170']
};
export const arrayLinesNight = ['150N'];
export const hourHiddenLinesNight = 20;

